  import { hasTag } from '@/utils/commonUtil'
  import { responsiveStyleValue } from '@/utils/constant'

  export default {
    data () {
      return {
        message: '',
        chattingRecords: [],
        keywords: [],
        questions: [],
        disease: '',
        diseaseId: '',
        questionShow: true,
        top: 0,
        paddingBottom: 115,
        showLoading: false,
        content: '',
        position: 'default',
        showPositionValue: false,
        tips: '',
        orgUid: '',
        title: '',
        questionKeyWord: '',
      }
    },
    methods:{
      send(){
        if (this.message) {
          let timestamp = new Date().getTime();
          this.addMessage(2, "", this.message, timestamp)
          this.keyword(this.message, timestamp);
          this.message = '';
        }
      },
      removeSpecialCharacter(key){
        return key.replace(/\?/g, "").replace(/ /g,"");
      },
      keyword(key, timestamp){
        if (key) {
          let that = this;
          let url = 'solr/allContent/' + this.removeSpecialCharacter(key) + '/0/5?category=' + this.disease
            + '&departmentId=' + this.diseaseId + '&orgUid=' + this.orgUid;
          this.sendRequest(url, timestamp, (req) => {
            document.getElementById(timestamp + '-loading').style.cssText = 'display:none';
            if (req.data && req.data.length > 0) {
              for(let item of req.data) {
                that.addMessage(1, item.title, item.content_html, null)
              }
            } else {
              that.addMessage(1, "这个问题我回答不上来，您可以使用其他关键字来咨询噢", "", null)
            }
          });
        }
      },
      question(key){
        if (key) {
          let timestamp = new Date().getTime();
          this.addMessage(2, "", key, timestamp)
          let that = this;
          let url = 'solr/title?category=' + this.disease + '&departmentId=' +
            this.diseaseId + '&orgUid=' + this.orgUid + '&key=' + this.removeSpecialCharacter(key);
          this.sendRequest(url, timestamp, (req) => {
            if (req.data && req.data.length > 0) {
              document.getElementById(timestamp + '-loading').style.cssText = 'display:none';
              that.addMessage(3, req.data[0].title, req.data[0].content_html, null)
            } else {
              this.tags(key,timestamp);
            }
          });
        }
      },
      tags(key, timestamp){
        if (key) {
          let that = this;
          let url = 'solr/' + this.removeSpecialCharacter(key) + '/0/5?category=' + this.disease
            + '&departmentId=' + this.diseaseId + '&orgUid=' + this.orgUid;
          this.sendRequest(url, timestamp, (req) => {
            if (req.data && req.data.length > 0) {
              document.getElementById(timestamp + '-loading').style.cssText = 'display:none';
              for(let item of req.data) {
                that.addMessage(1, item.title, item.content_html, null)
              }
            } else {
              that.keyword(key, timestamp);
            }
          });
        }
      },
      sendRequest(url, timestamp, successCallback) {
        this.$http.get(url, null,(req) => {
          successCallback(req)
        }, (error) => {
          console.log(error);
          document.getElementById(timestamp + '-loading').style.cssText = 'display:none';
          document.getElementById(timestamp + '-fail').style.cssText = 'display: flex;padding-right: 5px';
        });
      },
      addMessage(type, title, content, id) {
        // filter the full answer
        // such as：title='<h2>弱视</h2>' (answer's title), this.title='弱视' (department's title), 9 means length of '<h2></h2>'
        if (title.indexOf(this.title) < 0 || title.length != (this.title.length + 9)) {
          this.chattingRecords.push({type:type, title:title, content:content, id:id});
        }
      },
      getParams() {
        this.orgUid = this.$route.params.orgUid;
        this.disease = this.$route.query.enName;
        this.diseaseId = this.$route.query.id;
        this.questionKeyWord = this.$route.query.keyword;
        if (!this.diseaseId) {
          //报告H5那边仅传英文名，没有传id和中文名
          let url = 'department/' + this.disease + '/' + this.orgUid;
          this.$http.get(url, null,(res) => {
            this.diseaseId = res.data.id;
            this.title = res.data.cnName;
            this.$route.meta.title = this.title;
            this.getData();
          }, (error) => {
          });
        } else {
          this.title = this.$route.query.cnName;
          this.$route.meta.title = this.title;
          this.getData();
        }
        // 兼容H5报告解读时返回到报告详情页
        if (this.$route.query.redirect) {
          this.$router.go(-1)
        }
      },
      getData() {
        this.loading(true,'');
        //获取猜你想问关键字
        let url = 'keyword/list?departmentId=' + this.diseaseId;
        this.$http.get(url, null,(res) => {
          this.keywords = res.data;
          this.getQuestion();
          //如果有传问题关键字，则自动搜索答案
          if (this.questionKeyWord) {
            this.question(this.questionKeyWord)
          }
        }, (error) => {
          this.loading(false, '');
        });
      },
      getQuestion() {
        //获取猜您想问问题
        let questionUrl = 'question/list?departmentId=' + this.diseaseId;
        this.$http.get(questionUrl, null,(res) => {
          this.loading(false,'');
          this.questions = res.data;
          if (this.questions.length > 0) {
            this.questionShow = false;
            this.resetChatContentBoxStyle()
          }
        }, (error)=>{
          this.loading(false,'');
        });
      },
      resetChatContentBoxStyle(){
        this.top = responsiveStyleValue.SHOW_QUESTIONS_RELATIVE_TOP;
        //设置聊天内容box的padding-bottom
        this.paddingBottom = responsiveStyleValue.SHOW_KEYWORDS_PADDING_BOTTOM;
        if (!this.showKeyword()) {
          this.paddingBottom = responsiveStyleValue.HIDDEN_KEYWORDS_PADDING_BOTTOM;
        }
      },
      blurOrFocus(){
        //点击Input输入框外面的区域弹出的键盘隐藏
        let obj = document.getElementsByTagName('input')[0];
        let docTouchend = function(event){
          if (event.target != obj) {
            setTimeout(function(){
              obj.blur();
              document.removeEventListener('touchend',docTouchend,false);
            },100);
          }
        };
        if (obj) {
          obj.addEventListener('touchstart',function(){
            document.addEventListener('touchend',docTouchend,false);
          },false);
        }
      },
      preventAndStopEvent(){
        //当点击发送图标时，阻止时间冒泡，防止input失去焦点
        let that = this;
        let preventAndStop = function(event){
          event.preventDefault();
          event.stopPropagation();
          that.send();
        }
        document.querySelector('.input-send').addEventListener('touchend',preventAndStop,false);
      },
      loading(show, content) {
        this.showLoading = show;
        this.content = content;
      },
      showKeyword(){
        return hasTag(this.keywords, this.title)
      }
    },
    watch: {
      chattingRecords (newQuestion, oldQuestion) {
        this.$nextTick(() => {
          let container = document.querySelector("#chatContainer");
          container.scrollTop = container.scrollHeight;
        });
      },
      $route: 'getParams'
    },
    mounted () {
      //页面一加载就滚动到页面底部
      this.$nextTick(() => {
        var container = document.querySelector("#chatContainer");
        container.scrollTop = container.scrollHeight;
      });
      this.getParams();
      this.blurOrFocus();
      this.preventAndStopEvent();
    }
  }



// WEBPACK FOOTER //
// ./src/views/mixins/ChatMixin.js